import BackToTop from "@/assets/icon/back-to-top.svg";
const BackToTopIcon = () => {
  return <BackToTop />;
};
export default BackToTopIcon;